import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

// React-Bootstrap version of the OTP modal you provided.
// Usage: <OtpModal isOpen={show} onClose={handleClose} onVerify={verifyFn} onResend={resendFn} otp_id={otpId} />

export default function OtpModal({
  isOpen,
  onClose,
  onVerify,
  onResend,
  otp_id,
}) {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(120);
  const [resendCount, setResendCount] = useState(0);

  const timerRef = useRef(null);
  const inputRef = useRef(null);

  // Start Countdown Timer (Reusable)
  const startTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current); // clear previous
    setTimer(120);

    timerRef.current = setInterval(() => {
      setTimer((t) => {
        if (t <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
  };

  // When Modal Opens
  useEffect(() => {
    if (!isOpen) return;

    setOtp("");
    setResendCount(0);
    startTimer();

    setTimeout(() => inputRef.current && inputRef.current.focus(), 100);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isOpen]);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 6) setOtp(value);
  };

  const handleVerify = () => {
    if (otp.length === 6) onVerify(otp, otp_id);
  };

  const formattedTimer = () => {
    const s = timer % 60;
    const m = Math.floor(timer / 60);
    return m > 0 ? `${m}:${String(s).padStart(2, "0")}` : `${s}s`;
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      className="otp-modal"
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title className="modal-title">Enter OTP</Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-body custom-body px-4 pb-4 mx-3 mt-1 mb-3">
        <p className="text-center">
          A 6-digit OTP has been sent to your mobile number.
        </p>

        {/* OTP INPUT */}
        <Form.Group className="text-center my-3">
          <Form.Control
            ref={inputRef}
            type="text"
            value={otp}
            onChange={handleChange}
            maxLength={6}
            placeholder="Enter OTP"
            className="fs-4 text-center tracking-widest p-3"
            aria-label="Enter 6 digit OTP"
          />
        </Form.Group>

        {/* RESEND TIMER / BUTTON */}
        <div className="text-center mt-2">
          {resendCount >= 5 ? (
            <p className="text-danger fw-bold">
              Maximum resend attempts reached.
            </p>
          ) : timer > 0 ? (
            <p>
              Resend OTP in <strong>{formattedTimer()}</strong>
            </p>
          ) : (
            <Button
              variant="link"
              className="forgot-link mx-auto"
              onClick={() => {
                onResend && onResend(otp_id);
                setResendCount((c) => c + 1);
                startTimer(); // restart timer on resend
              }}
            >
              Resend OTP
            </Button>
          )}
        </div>

        <Modal.Footer className="d-flex flex-column border-0 p-0">
          <Button
            variant="none"
            className="w-100 my-3 btn-orange"
            onClick={handleVerify}
            disabled={otp.length !== 6}
          >
            Verify OTP
          </Button>

          <Button className="w-100 btn-light" onClick={onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
}
